import { render } from "./AlbumDetail.vue?vue&type=template&id=3a48bf0c"
import script from "./AlbumDetail.vue?vue&type=script&lang=js"
export * from "./AlbumDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__